export const NAME = 'core-export';
